module.exports = __webpack_public_path__ + "606b824672b5abfc290c003f45b656c5.svg";